import zhCN from './json/feed-back.zh_CN.json';
import zhTW from './json/feed-back.zh_TW.json';
import en from './json/feed-back.en.json';
import ja from './json/feed-back.ja.json';
import ko from './json/feed-back.ko.json';
import ru from './json/feed-back.ru.json';
export default {
  zh_CN: zhCN,
  zh_TW: zhTW,
  en,
  ja,
  ko,
  ru
};
